import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { TypedMemo } from '../common/types';
import { MobileAppHandoff } from './MobileAppHandoff';
import { HandoffBenefits } from './HandoffBenefits';
import { withBrandWord } from '../music24/components/primitives/BrandWord';

interface MobileAppHandoffModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Design music24-mobile-apps 1b: "Music24 on your phone", opened from the sidebar row (1c). */
const MobileAppHandoffModalComponent: React.FC<MobileAppHandoffModalProps> = ({ isOpen, onClose }) => {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg" className="sml-modal">
      <ModalHeader toggle={onClose}>
        {withBrandWord(
          intl.formatMessage({ id: 'app.sml.mobileApps.modal.title', defaultMessage: 'MUSIC24 on your phone' })
        )}
      </ModalHeader>
      <ModalBody>
        <MobileAppHandoff
          lead={intl.formatMessage({
            id: 'app.sml.mobileApps.modal.lead',
            defaultMessage: 'The same account and the same artists, on iPhone and Android.',
          })}
        >
          <HandoffBenefits />
        </MobileAppHandoff>
      </ModalBody>
    </Modal>
  );
};

export const MobileAppHandoffModal = TypedMemo(MobileAppHandoffModalComponent);
